// @ts-ignore

export function indexTouches(touches, points) {
  const obj = {};
  for (let i = 0; i < touches.length; i++) {
    obj[touches[i].identifier] = points[i];
  }
  return obj;
}